import { App } from 'vue'
import LpFragment from './LpFragment.vue'

LpFragment.install = (Vue: App) => {
  Vue.component(LpFragment.name, LpFragment)
}

export default LpFragment
